"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./utils/fetchRequest");
var UIConfigurationConnector_1 = __importDefault(require("./utils/UIConfigurationConnector"));
var PartyConnector_1 = __importDefault(require("./utils/PartyConnector"));
var AccountConnector_1 = __importDefault(require("./utils/AccountConnector"));
var AttachmentConnector_1 = __importDefault(require("./utils/AttachmentConnector"));
var SalesPolicyConnector_1 = __importDefault(require("./utils/SalesPolicyConnector"));
var RelationConnector_1 = __importDefault(require("./utils/RelationConnector"));
var SearchLovConnector_1 = __importDefault(require("./utils/SearchLovConnector"));
var UtilityConnector_1 = __importDefault(require("./utils/UtilityConnector"));
var PlatformConfigurationConnector_1 = __importDefault(require("./utils/PlatformConfigurationConnector"));
var PolicyConnector_1 = __importDefault(require("./utils/PolicyConnector"));
var OpportunityBasketConnector_1 = __importDefault(require("./utils/OpportunityBasketConnector"));
var SearchConfigurationConnector_1 = __importDefault(require("./utils/SearchConfigurationConnector"));
var SalesProductConnector_1 = __importDefault(require("./utils/SalesProductConnector"));
/**
 * API Connector for Claims journey designer
 */
var AgentApiConnector = /** @class */ (function () {
    /**
     * Instantiate an AgentApiConnector
     * Provide a key to look up access token
     * @param key key for the local storage item where access token is stored
     * @param baseUrl base url where connected API is running
     */
    function AgentApiConnector(key, baseUrl, site) {
        (0, fetchRequest_1.setAccessTokenKey)(key);
        (0, fetchRequest_1.setSite)(site);
        this.setLanguage('en-US');
        baseUrl = (0, fetchRequest_1.removeQuotes)(baseUrl);
        this.baseUrl = baseUrl.endsWith('/') ? baseUrl : "".concat(baseUrl, "/");
        this.uiConfiguration = new UIConfigurationConnector_1.default(this.baseUrl);
        this.party = new PartyConnector_1.default(this.baseUrl);
        this.account = new AccountConnector_1.default(this.baseUrl);
        this.salesPolicy = new SalesPolicyConnector_1.default(this.baseUrl);
        this.attachment = new AttachmentConnector_1.default(this.baseUrl);
        this.relation = new RelationConnector_1.default(this.baseUrl);
        this.searchLov = new SearchLovConnector_1.default(this.baseUrl);
        this.utility = new UtilityConnector_1.default(this.baseUrl);
        this.platformConfiguration = new PlatformConfigurationConnector_1.default(this.baseUrl);
        this.policy = new PolicyConnector_1.default(this.baseUrl);
        this.opportunityBasket = new OpportunityBasketConnector_1.default(this.baseUrl);
        this.searchConfiguration = new SearchConfigurationConnector_1.default(this.baseUrl);
        this.salesProduct = new SalesProductConnector_1.default(this.baseUrl);
    }
    /**
     * Method provides setting of language header on the API level
     * Default value will fallback to en
     * @param language language for setting language header
     */
    AgentApiConnector.prototype.setLanguage = function (language) {
        (0, fetchRequest_1.setLanguageHeader)(language);
    };
    return AgentApiConnector;
}());
exports.default = AgentApiConnector;
